import React from 'react';
import styled from 'styled-components';
import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';

const ErrorMessage = ({ error }) => {
  if (isString(error)) {
    return (
      <SingleErrorMessage>
        <FormattedMessage id={error} />
      </SingleErrorMessage>
    );
  }

  if (isArray(error)) {
    return (
      <ErrorsList>
        {
          error.map(error => (
            <li key={error}>
              <FormattedMessage id={error} />
            </li>
          ))
        }
      </ErrorsList>
    );
  }
};

ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
};

export default ErrorMessage;

const SingleErrorMessage = styled.div`
  color: ${colors.APPLE_BLOSSOM};
  margin-top: 10px;
`;

const ErrorsList = styled.ul`
  color: ${colors.APPLE_BLOSSOM};
  font-size: 15px;
  padding-left: 15px;
  line-height: 1.4;
  margin: 10px 0 0;
`;
